export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0004.50045826.webp";